import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import error from '../../assets/img/error.png';
import { creditHistoryVerifyViaAlternatePhoneNo } from '../../Actions/creditExperianHistoryAction';
import VerifyViaOTP from './VerifyViaOTP';
import { validateMobileNumber } from '../../Helper/common';

const VerifyViaPhoneNo = ({ onContinueClick, handleOnMatchAltNumber }) => {

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [selected, setSelected] = useState(false); // State to track radio button selection
    const [alternatePhoneData, setAlternatePhoneData] = useState (null);
    // const [otpSentOnMatchFlag, setOtpSentOnMatchFlag] = useState(false);
    const [phoneFormatError, setPhoneFormatError] = useState(false);

    const dispatch = useDispatch();
    const options = useSelector((state) => state.phoneNumbers); // Assuming phoneNumbers is stored in Redux state

    useEffect(() => {
        const fetchPhoneNumbers = async () => {
            dispatch(creditHistoryVerifyViaAlternatePhoneNo({type: 'GET_ALTERNATE_MOBILE_LIST',} ,getAlternatePhoneNumbers));
        };

        fetchPhoneNumbers();
    }, []);

    const handleRadioChange = () => {
        setSelected(true); // Set selected to true when radio button is clicked
        setSelectedOption("");
        setInputValue(''); // Clear input when option changes
        setPhoneNumberError(false); // Reset error when option changes
    };

    const handleVerifyClick = () => {
        onContinueClick();
        // Add logic for verify button click
        // console.log('Continue clicked:', handleVerifyClick);
    };

    const handleInputChange = (event) => {
        event?.preventDefault();
        setSelected(false); 
        setInputValue(event.target.value);
        setPhoneNumberError(false); // Reset error when input changes
    };

    const handleClearInput = (e) => {
        e?.preventDefault();
        setInputValue('');
        setPhoneNumberError(false); // Reset error when input is cleared
        setPhoneFormatError(false);
    };

    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
        setSelected(false); 
        setInputValue(''); // Clear input when option changes
        setPhoneNumberError(false); // Reset error when option changes
        setPhoneFormatError(false);
    };

    const handleSubmit = (event) => {
        event?.preventDefault();
        if (inputValue !== '1234' && false) {
            setPhoneNumberError(true); // Set error if phone number is incorrect
        } else {
            console.log(`Submitted phone number for option ${selectedOption}: ${inputValue}`);
            const verifyAlternatePhonePayload = {
                "mobileselect" : selectedOption,
                "mobilenumber": inputValue,
                "type": "VERIFY_ALTERNATE_NUMBER",
            }
            dispatch(creditHistoryVerifyViaAlternatePhoneNo(verifyAlternatePhonePayload, getAlternatePhoneValidation))
            // You can add further logic here to handle form submission
        }
    };

    const getAlternatePhoneNumbers = (result) => {
      const resultdemo =  {
            "success": 1,
            "type": "GET_ALTERNATE_MOBILE_LIST",
            "data": {
                "responseJson": "Please Call authenticateDeliveryData.action",
                "stgOneHitId": 1129111203,
                "stgTwoHitId": 1119534125,
                "maskMobileno": [
                    "83XXXXX274"
                ],
                "maskedEmailADDR": [
                    "EMAIL MATCHED."
                ]
            },
            "msg": "Mobile Number send successfully.",
            "api": 1,
            "CREDIT_BUREAU": "Experian"
        }
        setAlternatePhoneData(result); // change with result
    }

    const getAlternatePhoneValidation = (result) => {
        const notMatchedResult = {
            "success": 0,
            "type": "VERIFY_ALTERNATE_NUMBER",
            "msg": "Entered Phone number do not match with the selected number. Try using CRQ Request for Validation. :(TS api)",
            "api": 1,
            "CREDIT_BUREAU": "Experian"
        }
        const matchresult = {
            "success": 1,
            "type": "VERIFY_ALTERNATE_NUMBER",
            "msg": "OTP sent on changed phone number",
            "api": 1,
            "CREDIT_BUREAU": "Experian"
        }
        if(result?.success !== 1){
            setPhoneNumberError(true);
            // setOtpSentOnMatchFlag(false);
        } else {
            setPhoneNumberError(false);
            handleOnMatchAltNumber(selectedOption);
            // setOtpSentOnMatchFlag(true);
        }
    }

    const renderInputField = (optionValue, label) => {
        if (selectedOption === optionValue) {
            return (
                <>
                    <div className='d-flex justify-content-between'>
                        <input
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            className="form-control mt-2 w-100"
                            placeholder="Enter complete phone no."
                            value={inputValue}
                            style={{ width: 'calc(100% - 40px)' }}
                            onChange={(e) => {
                                handleInputChange(e);
                                const validFlag = validateMobileNumber(e?.target?.value);
                                // console.log("mobileflag...",validFlag)
                                setPhoneFormatError(!validFlag);
                            }}
                        />
                        {inputValue && (
                            <button
                                type="button"
                                className="btn btn-outline-light text-dark border border-0 btn-clear bg-white"
                                style={{
                                    position: 'relative',
                                    right: '25px',
                                    top: '4px',
                                    padding: '0 3px',
                                    margin: '8px -12px 8px 0',
                                }}
                                onClick={handleClearInput}
                            >
                                X
                            </button>
                        )}
                    </div>
                    {(phoneNumberError || phoneFormatError ) && (
                        <div
                            className='d-flex justify-content-around align-items-center error-div my-3'
                            style={{
                                padding: '10px 10px 10px 15px',
                                gap: '10px',
                                borderRadius: '4px',
                                border: '1px solid #F98652',
                                background: '#FFFBEF',
                            }}
                        >
                            <img src={error} alt="error" />
                            <p
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    lineHeight: '17.5px',
                                    textAlign: 'left',
                                    paddingTop: '13px',
                                }}
                            >{
                                phoneFormatError ? "Please Enter valid phone number" : "Phone number not matched. Try again or change phone no."
                            }
                            </p>
                        </div>
                    )}
                </>
            );
        }
        return null;
    };

    return (
        <>
        {
             <div className='mt-3'>
            <h6
                style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    lineHeight: '30px',
                    textAlign: 'left',
                }}
            >
                Verify via other phone number(s)
            </h6>
            <p
                className='text-dark'
                style={{
                    fontSize: '18px',
                    fontWeight: '400',
                    lineHeight: '21.24px',
                    textAlign: 'left',
                }}
            >
                Choose and confirm with the complete number to continue.
            </p>
            <form className='w-100' style={{ maxWidth: '500px' }}>
                {alternatePhoneData?.data?.maskMobileno?.map((mobileno) => (
                    <div
                        key={mobileno}
                        className="form-check my-2"
                        style={{
                            padding: '10px 13px 10px 13px',
                            gap: '10px',
                            borderRadius: '8px',
                            border: '1px solid #D0D5DD',
                        }}
                    >
                        <input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions"
                            id={mobileno}
                            value={mobileno}
                            style={{ width: '20px', height: '20px', marginInlineStart: '2px' }}
                            onChange={handleOptionChange}
                        />
                        <label
                            className="form-check-label"
                            htmlFor={mobileno}
                            style={{
                                fontSize: '16px',
                                fontWeight: '400',
                                lineHeight: '24px',
                                textAlign: 'left',
                                padding: '3px 36px',
                                cursor: 'pointer',
                            }}
                        >
                            {mobileno}
                        </label>
                        <br />
                        {renderInputField(mobileno, mobileno)}
                        {selectedOption === mobileno && (
                            <button type="submit" disabled={!inputValue} className={!!(phoneNumberError || phoneFormatError) ? 'btn btn-clear btn-primary mt-2' : 'btn btn-primary mt-2'} onClick={(e)=> {
                               if(!!(phoneNumberError || phoneFormatError)) {
                                handleClearInput(e);
                               } else {
                                handleSubmit(e);
                               } 
                            }}>
                                {!!(phoneNumberError || phoneFormatError) ? 'Clear' : 'Submit'}
                            </button>
                        )}
                    </div>
                ))}

                <hr style={{ border: '1px solid #D0D5DD' }} />

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="inlineRadioOptions"
                        id="exampleRadios2"
                        value="optionLast"
                        style={{ width: '20px', height: '20px', marginInlineStart: '-3px' }}
                        onChange={handleRadioChange}
                    />
                    <label
                        className="form-check-label"
                        htmlFor="exampleRadios2"
                        style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            lineHeight: '24px',
                            textAlign: 'left',
                            padding: '3px 36px',
                            cursor: 'pointer',
                        }}
                    >
                        I do not recognize any of the above phone numbers.
                    </label>
                </div>

                {selected && (
                    <div className="btn-box d-flex justify-content-between w-100 h-100 p-1 pt-3" style={{ maxWidth: '422px' }}>
                        <div className="btn w-100 btn-primary text-light" onClick={handleVerifyClick} style={{ cursor: 'pointer' }}>
                            Continue
                        </div>
                    </div>
                )}
            </form>
        </div>
        }
        </>
        
    );
};

export default VerifyViaPhoneNo;
